module.exports = __webpack_public_path__ + "static/media/An Chuilfhionn - Strings Version.4a358d7a.jpg";